export const name = 'siteRenderingContextService' as const
export const VIEWER_SERVICE_PACKAGE_NAME = '@wix/site-service-rendering-context' as const
